<template>
  <BaseListHeader class="text-sm cursor-default">
    <div class="flex -mx-3 text-sm">
      <div class="w-64 px-3" />
      <div class="flex-1 px-3 capitalize">
        {{ $te('name') ? $t('name') : 'name' }}
        /
        {{ $te('description') ? $t('description') : 'description' }}
      </div>
    </div>
  </BaseListHeader>
</template>

<script>
export default {
  name: 'ListHeader',
};
</script>
